var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeminiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9045 22.5017C21.7344 21.7603 20.1962 21.2062 18.4506 20.873V7.12729C20.1962 6.79407 21.7348 6.23999 22.9045 5.49851C23.1657 5.33298 23.2433 4.9869 23.0779 4.72568C22.9124 4.46419 22.566 4.38688 22.305 4.55232C20.5106 5.68936 17.5926 6.36812 14.5 6.36812C11.4074 6.36812 8.48915 5.68936 6.69481 4.55232C6.43332 4.3868 6.08752 4.46409 5.92199 4.72568C5.75647 4.9869 5.83404 5.33272 6.09535 5.49851C7.26521 6.23997 8.80365 6.79404 10.5492 7.12729V20.8732C8.80367 21.2064 7.26505 21.7605 6.09535 22.502C5.83413 22.6675 5.75655 23.0136 5.92199 23.2748C6.08751 23.536 6.43322 23.6133 6.69481 23.4482C8.48966 22.3111 11.4072 21.6321 14.4998 21.6321C17.5924 21.6321 20.5103 22.3111 22.305 23.4482C22.398 23.5069 22.5017 23.5352 22.6041 23.5352C22.7898 23.5352 22.9711 23.4431 23.0776 23.2748C23.2436 23.0135 23.1657 22.6674 22.9045 22.5019L22.9045 22.5017ZM11.6695 20.6935V7.30647C12.5767 7.42486 13.5256 7.48821 14.5001 7.48821C15.4745 7.48821 16.4234 7.42496 17.3306 7.30647V20.6935C16.4235 20.5751 15.4745 20.5118 14.5001 20.5118C13.5256 20.5118 12.5765 20.5751 11.6695 20.6935Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeminiIcon);
export default __webpack_public_path__ + "static/media/gemini-icon.20fc8b7aeb3b34f62768ea539118d422.svg";
export { ForwardRef as ReactComponent };